import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SessionItemResultWrapper;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { jsx } from '@instructure/emotion';
import { featureOn, CustomPropTypes, SessionItemResultView as SessionItemResult } from '@instructure/quiz-core';
import GradingBar from '../GradingBar';
import RegradeOverride from '../../quizEntry/RegradeOverride';
import { CLEAR_ALL_INPUT_VALIDATION_ERRORS, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var SessionItemResultWrapper = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SessionItemResultWrapper = /*#__PURE__*/function (_Component) {
  function SessionItemResultWrapper() {
    var _this;
    _classCallCheck(this, SessionItemResultWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SessionItemResultWrapper, [].concat(args));
    _defineProperty(_this, "state", {
      graderFeedback: _this.props.graderFeedback,
      validationErrorsFromApi: {}
    });
    _defineProperty(_this, "gradingBar", null);
    _defineProperty(_this, "_timeouts", []);
    _defineProperty(_this, "startFeedbackEdit", function () {
      if (!_this.props.isEditing) {
        _this.props.switchOnEditing();
      }
    });
    _defineProperty(_this, "closeFeedbackEdit", function () {
      var _this$gradingBar;
      _this.props.switchOffEditing();
      (_this$gradingBar = _this.gradingBar) === null || _this$gradingBar === void 0 || (_this$gradingBar = _this$gradingBar.getWrappedInstance()) === null || _this$gradingBar === void 0 || _this$gradingBar.focusFeedbackButton();
    });
    _defineProperty(_this, "submitFeedbackEdit", function () {
      _this.props.handleChangeFeedback(_this.props.sessionItem.id, _this.props.item.id, {
        graderFeedback: _this.state.graderFeedback.toJS()
      });
      _this.closeFeedbackEdit();
    });
    _defineProperty(_this, "updateFeedbackEdit", function (e, _ref) {
      var editorContent = _ref.editorContent;
      _this.setState({
        graderFeedback: Map({
          content: editorContent
        })
      });
    });
    // =============
    //   HANDLERS
    // =============
    _defineProperty(_this, "setActiveItem", function () {
      if (_this.props.gradeByQuestionEnabled) {
        _this.props.setActiveItem(_this.props.item.id);
      }
    });
    _defineProperty(_this, "handleRegradingEditModeToggle", function () {
      _this.props.toggleRegradingEditMode(_this.props.regradingKey);
    });
    _defineProperty(_this, "handleRegradingOnCancel", function (sessionItemId) {
      _this.clearValidationErrorsFromApi(CLEAR_ALL_INPUT_VALIDATION_ERRORS);
      _this._timeouts = _this._timeouts.concat(setTimeout(function () {
        var _this$gradingBar2;
        return (_this$gradingBar2 = _this.gradingBar) === null || _this$gradingBar2 === void 0 || (_this$gradingBar2 = _this$gradingBar2.getWrappedInstance()) === null || _this$gradingBar2 === void 0 ? void 0 : _this$gradingBar2.focusRegradeButton();
      }));
    });
    _defineProperty(_this, "handleGradingBarRef", function (node) {
      _this.gradingBar = node;
    });
    _defineProperty(_this, "handleValidationErrorsFromApi", function (errors) {
      _this.setState({
        validationErrorsFromApi: errors
      });
    });
    _defineProperty(_this, "clearValidationErrorsFromApi", function (inputId) {
      if (inputId === CLEAR_ALL_INPUT_VALIDATION_ERRORS) {
        _this.setState({
          validationErrorsFromApi: {}
        });
      }
      if (_this.state.validationErrorsFromApi[inputId]) {
        var newErrors = Object.assign({}, _this.state.validationErrorsFromApi);
        delete newErrors[inputId];
        _this.setState({
          validationErrorsFromApi: newErrors
        });
      }
    });
    // =============
    //   RENDERING
    // =============
    _defineProperty(_this, "renderRegradeOverride", function (sessionItem, item) {
      return jsx(RegradeOverride, {
        displayPosition: sessionItem.position,
        guid: sessionItem.id,
        onCancel: _this.handleRegradingOnCancel,
        itemId: item.id,
        quizSessionId: _this.props.quizSessionId,
        sessionItem: sessionItem,
        validationErrorsFromApi: _this.state.validationErrorsFromApi,
        handleValidationErrorsFromApi: _this.handleValidationErrorsFromApi,
        clearValidationErrorsFromApi: _this.clearValidationErrorsFromApi
      });
    });
    return _this;
  }
  _inherits(SessionItemResultWrapper, _Component);
  return _createClass(SessionItemResultWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeouts.forEach(clearTimeout);
    }
  }, {
    key: "isAutogradeable",
    value: function isAutogradeable() {
      var notAutogradeableTypes = ['essay', 'file-upload'];
      return !notAutogradeableTypes.includes(this.props.item.getInteractionType().slug);
    }
  }, {
    key: "isSubjective",
    value: function isSubjective() {
      return this.props.item.getInteractionType().isSubjective;
    }
  }, {
    key: "renderResult",
    value: function renderResult(sessionItem, item) {
      var _this$props = this.props,
        handleChangeGradeStatus = _this$props.handleChangeGradeStatus,
        handleChangePoints = _this$props.handleChangePoints,
        itemResultsModifications = _this$props.itemResultsModifications,
        sessionItemResult = _this$props.sessionItemResult,
        shouldRenderTopBorder = _this$props.shouldRenderTopBorder;
      return jsx("div", {
        css: this.props.styles.root,
        "data-automation": "sdk-grading-result-wrapper",
        tabIndex: "-1",
        onFocus: this.setActiveItem
      }, jsx("div", {
        css: this.props.styles.result
      }, jsx(SessionItemResult, {
        appContainer: this.props.appContainer,
        editGraderFeedback: this.startFeedbackEdit,
        hideGraderFeedback: this.props.isEditing,
        item: item,
        sessionItem: sessionItem,
        sessionItemResult: sessionItemResult,
        shouldRenderTopBorder: shouldRenderTopBorder
      })), jsx("div", {
        css: this.props.styles.gradingBar
      }, jsx(GradingBar, {
        appContainer: this.props.appContainer,
        ref: this.handleGradingBarRef,
        cancelFeedbackEdit: this.closeFeedbackEdit,
        graderFeedback: this.state.graderFeedback,
        handleChangeGradeStatus: handleChangeGradeStatus,
        handleChangePoints: handleChangePoints,
        isAutogradeable: this.isAutogradeable(),
        isEditing: this.props.isEditing,
        isSubjective: this.isSubjective(),
        itemResultsModifications: itemResultsModifications,
        regradeToggleAction: this.handleRegradingEditModeToggle,
        renderUpdateButton: this.props.renderUpdateButton,
        sessionItem: sessionItem,
        sessionItemResult: sessionItemResult,
        startFeedbackEdit: this.startFeedbackEdit,
        submitFeedbackEdit: this.submitFeedbackEdit,
        updateFeedbackEdit: this.updateFeedbackEdit
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        sessionItem = _this$props2.sessionItem,
        item = _this$props2.item;
      if (this.props.isRegrading && featureOn('regrading_from_speedgrader')) {
        return this.renderRegradeOverride(sessionItem, item);
      } else {
        return this.renderResult(sessionItem, item);
      }
    }
  }]);
}(Component), _defineProperty(_SessionItemResultWrapper, "displayName", 'SessionItemResultWrapper'), _defineProperty(_SessionItemResultWrapper, "componentId", "Quizzes".concat(_SessionItemResultWrapper.displayName)), _defineProperty(_SessionItemResultWrapper, "propTypes", {
  activeItemId: PropTypes.string,
  appContainer: CustomPropTypes.selectors.isRequired,
  handleChangeFeedback: PropTypes.func.isRequired,
  handleChangeGradeStatus: PropTypes.func.isRequired,
  handleChangePoints: PropTypes.func.isRequired,
  gradeByQuestionEnabled: PropTypes.bool,
  graderFeedback: ImmutablePropTypes.map.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isRegrading: PropTypes.bool.isRequired,
  item: ImmutablePropTypes.record.isRequired,
  itemResultsModifications: ImmutablePropTypes.map.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  regradingKey: PropTypes.string.isRequired,
  renderUpdateButton: PropTypes.func.isRequired,
  sessionItem: ImmutablePropTypes.record.isRequired,
  sessionItemResult: ImmutablePropTypes.record.isRequired,
  setActiveItem: PropTypes.func.isRequired,
  shouldRenderTopBorder: PropTypes.bool.isRequired,
  switchOffEditing: PropTypes.func.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  toggleRegradingEditMode: PropTypes.func.isRequired,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_SessionItemResultWrapper, "defaultProps", {
  activeItemId: null,
  gradeByQuestionEnabled: false
}), _SessionItemResultWrapper)) || _class);
export default SessionItemResultWrapper;